import { motion } from 'framer-motion';

const caseStudies = [
  {
    company: 'Müller Handwerk',
    industry: 'Handwerk & Dienstleistung',
    image: 'https://public.readdy.ai/ai/img_res/19eac5910f83d4938122fde68110ec3b.jpg',
    metrics: [
      { value: '300%', label: 'Mehr Anfragen' },
      { value: '85%', label: 'Mehr Sichtbarkeit' },
      { value: '1,8s', label: 'Ladezeit' },
      { value: 'Seite 1', label: 'Google Ranking' }
    ],
    description: 'Durch eine neue Webseite, lokale SEO-Optimierung und einen AI-Chatbot für Terminbuchungen hat Müller Handwerk seine Online-Anfragen verdreifacht.'
  },
  {
    company: 'Schmidt & Partner',
    industry: 'Beratung & Finanzen',
    image: 'https://readdy.ai/api/search-image?query=professional%20german%20finance%20consulting%20team%20of%20business%20professionals%20smiling%20and%20celebrating%20success%20in%20modern%20corporate%20office%2C%20diverse%20group%20of%20colleagues%20working%20together%20with%20laptops%20and%20data%20displays%2C%20warm%20natural%20lighting%20with%20beige%20and%20green%20tones%2C%20authentic%20workplace%20photography%20showing%20achievement%20and%20collaboration&width=600&height=400&seq=casestudy-schmidt-team-v1&orientation=landscape',
    metrics: [
      { value: '400%', label: 'Umsatzwachstum' },
      { value: '90%', label: 'Kundenzufriedenheit' },
      { value: '60%', label: 'Mehr Leads' },
      { value: '5x', label: 'ROI' }
    ],
    description: 'Schmidt & Partner hat durch ein Premium Redesign, Performance-Optimierung und AI-gestützte Automatisierung seinen Umsatz vervierfacht.'
  }
];

export default function CaseStudy() {
  return (
    <section className="py-20 sm:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
          className="text-center mb-16 sm:mb-20"
        >
          <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-caprasimo mb-4 sm:mb-6 text-brand-black px-4">
            Erfolgsgeschichten
          </h2>
          <p className="text-lg sm:text-xl text-brand-grey max-w-3xl mx-auto px-4">
            Sehen Sie, wie Unternehmen mit BR Webdesign & AI Solutions ihre Online-Präsenz transformiert haben
          </p>
        </motion.div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 sm:gap-12">
          {caseStudies.map((study, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: index * 0.2 }}
              viewport={{ once: true }}
              className="group bg-brand-beige-light rounded-3xl overflow-hidden hover:shadow-2xl transition-all border border-brand-beige hover:border-brand-green"
            >
              <div className="relative h-64 overflow-hidden">
                <img
                  src={study.image}
                  alt={study.company}
                  className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-700"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-brand-black/60 to-transparent"></div>
                <div className="absolute bottom-6 left-6">
                  <div className="text-2xl sm:text-3xl font-caprasimo text-white mb-1">{study.company}</div>
                  <div className="text-sm sm:text-base text-brand-beige-light">{study.industry}</div>
                </div>
              </div>

              <div className="p-6 sm:p-8">
                <div className="grid grid-cols-2 sm:flex sm:gap-6 gap-4 mb-6">
                  {study.metrics.map((metric, i) => (
                    <div key={i} className="flex-1">
                      <div className="text-2xl sm:text-3xl font-caprasimo text-brand-green mb-1">{metric.value}</div>
                      <div className="text-xs sm:text-sm text-brand-grey">{metric.label}</div>
                    </div>
                  ))}
                </div>

                <p className="text-brand-grey leading-relaxed mb-6 text-sm">{study.description}</p>

                <a 
                  href="/contact" 
                  className="inline-flex items-center gap-2 text-brand-green font-semibold hover:gap-4 transition-all cursor-pointer min-h-[44px] py-2"
                >
                  Ähnliches Projekt starten
                  <i className="ri-arrow-right-line"></i>
                </a>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}